export default "__VITE_ASSET__BL016j1A__"